module.exports = __webpack_public_path__ + "media/images/facebook-image-a1dd3e3573dd50516f3f25e88961cc00.jpg";